import React, { useEffect, useState, useRef } from 'react';
import axios, { formToJSON } from 'axios';
import { useParams } from 'react-router-dom';
import $, { data } from 'jquery';
import 'select2';
import '../css/Select2.css';
import '../css/Login.css';
import '../css/Materialize.css';
import '../css/Style.css';
import '../css/new.css';
import reloadToken from '../helper/reloadtoken';
import helperFilter from '../helper/helperfilter';
import HeaderMenu from '../template/HeaderMenu';
import { apiConfig } from '../helper/apiConfig';
import { hide, sumDataKerja, getFrozen, createRatioZoom, getRatioZoom, saveheighrow, getheighrow, removeComma, getFilterPageAll, getFilterPageAllJson } from '../helper/hide';
import { ToastContainer, toast } from 'react-toastify';
import { dataconfig, showtoolbarConfig } from '../helper/luckysheetHelper';
import 'react-toastify/dist/ReactToastify.css';
// import Modal from './modal_doc_perusahaan';
// import Modalpreview from './modalpreview';
import Convertformatlucky from '../helper/convertformatlucky';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Message from '../helper/messages';
import { encrypt, decrypt, AesEncrypt } from '../helper/Decrypte';
import messages from '../helper/messages';
import { faArrowLeft, faSearch } from '@fortawesome/free-solid-svg-icons';

import { DownloadTableExcel } from 'react-export-table-to-excel';
import { useDownloadExcel } from 'react-export-table-to-excel';
import {utils, writeFile} from 'xlsx';

const title_form = "DATA PERUSAHAAN / GROUP";
const sub_title_form = ""
const tipedata = "PERUSAHAAN";
const historyback = 'perusahaan'
const mainhost = process.env.REACT_APP_API_HOST_MASTER;
const hostcc = process.env.REACT_APP_API_HOST_COLOR_COMMENT;
const hostdrop = process.env.REACT_APP_API_HOST_DROPDOWN;
const hostdatcont = process.env.REACT_APP_API_HOST_DATA_CONT;

const API_Datainout = mainhost + "DatainoutData"
const API_NewDatainout = mainhost + "DatainoutNew"
const API_ActiveDatainout = mainhost + "DatainoutActive"
const API_PercentDatainout = mainhost + "DatainoutPercent"
const API_PT_DROPDOWN = mainhost + "KasForDropdown"


const API_DatainoutList = mainhost + "DatainoutList"
const API_DatainoutReportToko = mainhost + "DatainoutReportToko"
const API_AssetReportAllDivisionToko = mainhost + "AssetReportAllDivisionToko"
const API_AssetReportAllDivision = mainhost + "AssetReportAllDivision"
const API_AssetReportPusatToko = mainhost + "AssetReportPusatToko"
const API_AssetReportPusat = mainhost + "AssetReportPusat"
const API_AssetSumarryReportToko = mainhost + "AssetReportSumarryDToko"
const API_AssetSumarryReportPiutang = mainhost + "AssetReportPiutang"
const API_DatainoutSumarryReportToko = mainhost + "DatainoutReportSumarryToko"
const API_AssetDatainoutReportToko = mainhost + "AssetDatainoutReportToko"
const API_AssetDatainoutReportSaldo = mainhost + "AssetDatainoutReportSaldo"


const currentUrl = window.location.href;

const notify_cant_update_br_cont = (message, time = 800) => {
  toast.error(<div dangerouslySetInnerHTML={{ __html: message }} />, {
    position: toast.POSITION.TOP_CENTER,
    autoClose: time,
  });
};

const notify_update_br_cont = (message, time = 2000) => {
  toast.success(<div dangerouslySetInnerHTML={{ __html: message }} />, {
    position: toast.POSITION.TOP_CENTER,
    autoClose: time,
  });
};

const ReportAllDivision = () => {
  const token = localStorage.getItem('token');

  const [TokenNew, setToken] = useState(null);
  const [DatainoutData, setDatainoutData] = useState(null);
  const [DatainoutReportToko, setDatainoutReportToko] = useState(null);
  const [ReportAllDivisionToko, setReportAllDivisionToko] = useState(null);
  const [AssetReportAllDivision, setAssetReportAllDivision] = useState(null);
  const [ReportPusatToko, setReportPusatToko] = useState(null);
  const [ReportPusat, setReportPusat] = useState(null);
  const [ReportPiutang, setReportPiutang] = useState(null);
  const [AssetSumarryReportToko, setAssetSumarryReportToko] = useState(null);
  const [DatainoutReportSumarryToko, setAssetDatainoutReportSumarryToko] = useState(null);
  const [DatainoutReportSaldo, setAssetDatainoutReportSaldo] = useState(null);
  const [DatainoutSumarryReportToko, setDatainoutSumarryReportToko] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingModal, setIsLoadingModal] = useState(true);
  const tableSummary = useRef(null); const tableDataInOut = useRef(null); const tablePcash1 = useRef(null); const tablePcash2 = useRef(null); const tablePcash3 = useRef(null); const tableSumRef1 = useRef(null); const tableSumRef2 = useRef(null); const tableSubSummary = useRef(null); const tableSubExpense = useRef(null); const tablePiutang = useRef(null); const tableModalSub = useRef(null);
  const config = apiConfig(token);

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, index) => currentYear - index);
  const current_month = new Date().getMonth() + 1;

  const selectForBln = useRef(null);
  const selectForYearh = useRef(null);

  const year_local = localStorage.getItem("year_selected");
  const month_local = localStorage.getItem("month_selected");

  const year_selected = year_local ?  parseInt(year_local) : years[0]
  const month_selected = month_local ? parseInt(month_local) : current_month

  const [selectedYear, setSelectedYear] = useState(year_selected);
  const [selectedMonth, setSelectedMonth] = useState(month_selected);
  const [KasList, setKasList] = useState([]);

  const months = [
    { value: '1', label: 'Januari' },
    { value: '2', label: 'Februari' },
    { value: '3', label: 'Maret' },
    { value: '4', label: 'April' },
    { value: '5', label: 'Mei' },
    { value: '6', label: 'Juni' },
    { value: '7', label: 'Juli' },
    { value: '8', label: 'Agustus' },
    { value: '9', label: 'September' },
    { value: '10', label: 'Oktober' },
    { value: '11', label: 'November' },
    { value: '12', label: 'Desember' },
  ];
  

  const exportToExcel = (data_excel, filename) => {
    const workbook = utils.book_new();
  
    // Loop through each sheet data object
    data_excel.forEach((sheet) => {
      const worksheet = utils.json_to_sheet(sheet.data);
  
      // Add optional column headers if defined
      if (sheet.columns) {
        utils.sheet_add_aoa(worksheet, sheet.columns, { origin: 'A1' });
      }
      // Apply zebra striping to data rows (starting from row 1 after headers)
      sheet.data.forEach((_, rowIndex) => {
        const isEvenRow = rowIndex % 2 === 0;
        Object.keys(sheet.data[0]).forEach((_, colIndex) => {
          const cellAddress = utils.encode_cell({ r: rowIndex + 1, c: colIndex });
          if (!worksheet[cellAddress]) return;  // Check if cell exists
          worksheet[cellAddress].s = {
            fill: { fgColor: { rgb: isEvenRow ? "F2F2F2" : "FFFFFF" } } // Light gray for even rows, white for odd rows
          };
        });
      });
      // Append the sheet to the workbook
      utils.book_append_sheet(workbook, worksheet, sheet.name);
    });
    writeFile(workbook, filename+'.xlsx');
  };

  const fetchDropdownOptions = async () => {
    try {
      const config = apiConfig(token);
      const response = await axios.post(`${API_PT_DROPDOWN}`, null, config);
      return response.data;
    } catch (error) {
      console.error('Error fetching column names:', error);
      return [];
    }
  };

  const getDatainoutData = async () => {
    try {

      const formData = new FormData();
        formData.append('bln',month_selected);
        formData.append('thn',year_selected);
        // formData.append('email', user);
        // formData.append('password', pass);
        const response = await axios.post(`${API_Datainout}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const getReportToko = async () => {
    try {

      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      const response = await axios.post(`${API_DatainoutReportToko}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const getReportAllDivisionToko = async () => {
    try {

      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      const response = await axios.post(`${API_AssetReportAllDivisionToko}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const getReportPusatToko = async () => {
    try {

      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      const response = await axios.post(`${API_AssetReportPusatToko}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const getReportPusatPiutang = async () => {
    try {

      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      const response = await axios.post(`${API_AssetSumarryReportPiutang}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const getSUMarryReportToko = async () => {
    try {

      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      const response = await axios.post(`${API_AssetSumarryReportToko}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const getSUMarryReportDatainout = async () => {
    try {

      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      const response = await axios.post(`${API_AssetDatainoutReportToko}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const getDataInoutSUMarryReportToko = async () => {
    try {

      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      const response = await axios.post(`${API_DatainoutSumarryReportToko}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const getDatainoutReportSaldo = async () => {
    try {

      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      const response = await axios.post(`${API_AssetDatainoutReportSaldo}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const getReportPusat = async () => {
    try {

      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      const response = await axios.post(`${API_AssetReportPusat}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const getModalSubSummary = async (item,item2,item3) => {
    try {

      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      formData.append('asset', item);
      formData.append('pcash', item3);
      formData.append('kategori', item2);

      const API_AssetReportModalSubSummary = mainhost + "AssetReportModalSubSummary"
      const response = await axios.post(`${API_AssetReportModalSubSummary}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const getReportAllDivision = async () => {
    try {

      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      const response = await axios.post(`${API_AssetReportAllDivision}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const handleNewDatainout = async () => {
    const newDatainout = document.getElementById('new_asset').value;
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append('asset', newDatainout);
      const response = await axios.post(`${API_NewDatainout}`, formData, config);
      const data = response.data;
      if (data.status === 200) {
        notify_update_br_cont(data.message);
        document.getElementById('new_asset').value = '';
      } else {
        notify_cant_update_br_cont(data.message);
      }
      const asset_data = await getDatainoutData();
      setDatainoutData(asset_data);
      setIsLoading(false);
    }
    catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const handleActiveDatainout = async (id) => {
    setIsLoading(true);
    DatainoutData.map((item) => {
      if (item.id === id) {
        if (item.active === '1') {
          item.active = '0';
        }
        else {
          item.active = '1';
        }
      }
    });
    setIsLoading(false);
    try {
      const formData = new FormData();
      formData.append('id', id);
      const response = await axios.post(`${API_PercentDatainout}`, formData, config);
      const data = response.data;
      if (data.status === 200) {
        notify_update_br_cont(data.message);
        document.getElementById('new_asset').value = '';
      } else {
        notify_cant_update_br_cont(data.message);
      }
    }
    catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const handleChange = () => {

  }

  const handleMonthChange = (event) => {
    const value = event.target.value;
    let intValue;
    if (value.trim() !== '') {
         intValue = parseInt(value, 10);
        if (!isNaN(intValue)) {
        } else {
          intValue="";
        }
    } else {
      intValue="";
    }
    setSelectedMonth(intValue);
    localStorage.setItem("month_selected", intValue);
    window.location.reload();
  }

  const handleSelectYearChange = (year) => {
    const value = year.target.value;
    let intValue = parseInt(value, 10);
    if (!isNaN(intValue)) {
      setSelectedYear(intValue); // Update selected year state
      localStorage.setItem("year_selected", intValue); // Store in local storage
    } else {
      setSelectedYear(""); // Reset selected year state
      localStorage.removeItem("year_selected"); // Remove from local storage
    }
    window.location.reload();
  }

  const handlePercentDatainout = async (id,e) => {
    setIsLoading(true);
    DatainoutData.map((item) => {
      if (item.id === id) {
        item.percentage = e.target.value;
      }
    });
    setIsLoading(false);
    try {
      const formData = new FormData();
      formData.append('id', id);
      formData.append('percentage', e.target.value);
      const response = await axios.post(`${API_PercentDatainout}`, formData, config);
      const data = response.data;
      if (data.status === 200) {
        notify_update_br_cont(data.message);
        document.getElementById('new_asset').value = '';
      } else {
        notify_cant_update_br_cont(data.message);
      }
    }
    catch (error) {
      console.error('Error fetching data:', error);
    }
  }


  $(selectForBln.current).on('change', handleMonthChange);
  $(selectForYearh.current).on('change', handleSelectYearChange);

  useEffect(() => {
    setIsLoading(true);
    //TYPE
    $('.js-example-basic-single').select2();
    $('.js-example-basic-multiple').select2({
      theme: "classic"
    });

    const getIdFromUrl = () => {
      const urlParts = window.location.href.split('/');
      const id = urlParts[urlParts.length - 1];
      return id;
    };
    // const intervalId = setInterval(cekFile, 3600000);//1 jam

    const fetchData = async () => {
      await new Promise((resolve) => setTimeout(resolve, 100));
      const newToken = await reloadToken();
      setToken(newToken);
      // const asset_data = await getDatainoutData();
      // setDatainoutData(asset_data);
      // const report_toko = await getReportToko();
      // setDatainoutReportToko(report_toko);
      const sum_report_allDivision = await getReportAllDivisionToko();
      setReportAllDivisionToko(sum_report_allDivision);
      const sumarry_report_toko = await getReportAllDivision();
      setAssetReportAllDivision(sumarry_report_toko);
      const summary_pusat_toko = await getReportPusatToko();
      setReportPusatToko(summary_pusat_toko);
      const summary_pusat = await getReportPusat();
      setReportPusat(summary_pusat);
      const summary_piutang = await getReportPusatPiutang();
      setReportPiutang(summary_piutang);
      const sumarry_toko = await getSUMarryReportToko();
      setAssetSumarryReportToko(sumarry_toko);
      const sumarry_report_datainout = await getSUMarryReportDatainout();
      setDatainoutSumarryReportToko(sumarry_report_datainout);

      const sumarry_reportToko_datainout = await getDataInoutSUMarryReportToko();
      setAssetDatainoutReportSumarryToko(sumarry_reportToko_datainout);
      const sumarry_DatainoutReportSaldo = await getDatainoutReportSaldo();
      setAssetDatainoutReportSaldo(sumarry_DatainoutReportSaldo);
      const kas_list_data = await fetchDropdownOptions();
      for (let i = 0; i < kas_list_data.length; i++) {
        if (kas_list_data[i].value === "9") {
          kas_list_data.splice(i, 1);
          break;
        }
      }
      for (let i = 0; i < kas_list_data.length; i++) {
        if (kas_list_data[i].value === "10") {
          kas_list_data.splice(i, 1);
          break;
        }
      }
      setKasList(kas_list_data);
      setIsLoading(false);
    };

    new Promise((resolve) => setTimeout(resolve, 100));

    function isMobileDevice() {
      const mobileScreenWidth = 768;
      return window.innerWidth < mobileScreenWidth;
    }

    setTimeout(function () {
      var calcChainLength = 0;

    }, 1500);

    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      setToken(storedToken);
    } else {
      // If token is not found in localStorage, reload it
      reloadToken().then(newToken => {
        setToken(newToken);
        // Store the token in localStorage for future use
        localStorage.setItem('token', newToken);
      });
    }

    fetchData();
    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log('Tab is hidden');
        // luckysheet.refresh();
      } else {
        console.log('Tab is visible');
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      // clearInterval(intervalId);

      $(selectForBln.current).on('change', handleMonthChange);
      $(selectForYearh.current).on('change', handleSelectYearChange);
    };
  }, []);

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const formatNumberWithoutDecimals = (num) => {
    // convert num into float
    num = parseFloat(num);
    if (isNaN(num)) {
      return '0';
    }
    return num.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  };
  const selectStyle120 = {
    // Define your custom CSS styles here
    border: '1px solid #ccc',
    borderRadius: '4px',
    padding: '2px',
    fontSize: '16px',
    width: '120px',
    height: '10%',
    marginTop: '5px',
  };
  const labelStyel = {
    marginTop: '22px',
  };
  const randomKey = () => {
    return Math.random().toString(36).substr(2, 9);
  }
  const datainout1 = () => {

    // Proses tableDataInOut
    const dataTable_sum = tableDataInOut.current;
    const data = [];

    // Extract headers from the table
    const headers = Array.from(dataTable_sum.querySelectorAll('thead th')).map((th) => th.textContent);

    // Extract data from the table body
    const tableBody = dataTable_sum.querySelector('tbody');
    const rows = Array.from(tableBody.querySelectorAll('tr'));
    const dataRows = rows.map((row) => Array.from(row.querySelectorAll('td')).map((td) => td.textContent));

    return [headers, dataRows];
  }
  const tableModalSub1 = () => {

    // Proses tableDataInOut
    const dataTable_sum = tableModalSub.current;
    const data = [];

    // Extract headers from the table
    const headers = Array.from(dataTable_sum.querySelectorAll('thead th')).map((th) => th.textContent);

    // Extract data from the table body
    const tableBody = dataTable_sum.querySelector('tbody');
    const rows = Array.from(tableBody.querySelectorAll('tr'));
    const dataRows = rows.map((row) => Array.from(row.querySelectorAll('td')).map((td) => td.textContent));

    return [headers, dataRows];
  }
  const pcash1 = () => {

    // Proses tablePcash1
    const dataTable_sum = tablePcash1.current;
    const data = [];

    // Extract headers from the table
    const headers = Array.from(dataTable_sum.querySelectorAll('thead th')).map((th) => th.textContent);

    // Extract data from the table body
    const tableBody = dataTable_sum.querySelector('tbody');
    const rows = Array.from(tableBody.querySelectorAll('tr'));
    const dataRows = rows.map((row) => Array.from(row.querySelectorAll('td')).map((td) => td.textContent));

    return [headers, dataRows];
  }
  const pcash2 = () => {

    // Process TablePCash2
    const dataTable_sum2 = tablePcash2.current;
    const headers = Array.from(dataTable_sum2.querySelectorAll('thead th')).map((th) => th.textContent);
    const tableBody = dataTable_sum2.querySelector('tbody');
    const rows = Array.from(tableBody.querySelectorAll('tr'));
    const dataRows = rows.map((row) => Array.from(row.querySelectorAll('td')).map((td) => td.textContent));

    return [headers, dataRows];
  }
  const onDownloadPCash  = () => {

    const data = [];

    const pcash11 = pcash1();
    const headers = pcash11[0];
    const dataRows = pcash11[1];

    const pcash22 = pcash2();
    const headers2 = pcash22[0];
    const dataRows2 = pcash22[1];
    
    // Combine headers and data into the desired format
    data.push({
      name: 'Sum',
      data: [...dataRows],
      columns : [headers]
    },{
      name: 'Sum Kas',
      data: [...dataRows2],
      columns : [headers2]
    });
    // const data = [
    //   {
    //     name: 'Sum',
    //     data: [
    //       ['Keterangan', 'In', 'Out', 'Jumlah'],
    //       ['Kas', '1', '2', '3'],
    //       ['Bank', '4', '5', '6'],
    //       ['Total', '7', '8', '9'],
    //     ],
    //   },
    // ];
    exportToExcel(data,'PCash');
  }
  const sum1 = () => {
    const dataTable_sum = tableSumRef1.current;

    // Extract headers from the table
    const headers = Array.from(dataTable_sum.querySelectorAll('thead th')).map((th) => th.textContent);

    // Extract data from the table body
    const tableBody = dataTable_sum.querySelector('tbody');
    const rows = Array.from(tableBody.querySelectorAll('tr'));
    const dataRows = rows.map((row) => Array.from(row.querySelectorAll('td')).map((td) => td.textContent));

    return [headers, dataRows];
  }
  const sum2 = () => {
    // Process tableSumRef2
    const dataTable_sum2 = tableSumRef2.current;
    const headers2 = Array.from(dataTable_sum2.querySelectorAll('thead th')).map((th) => th.textContent);
    const tableBody2 = dataTable_sum2.querySelector('tbody');
    const rows2 = Array.from(tableBody2.querySelectorAll('tr'));
    const dataRows2 = rows2.map((row) => Array.from(row.querySelectorAll('td')).map((td) => td.textContent));

    return [headers2, dataRows2];
  }
  const onDownloadSummary  = () => {

    // Proses tableSumRef1
    const data = [];
    
    const sum11 = sum1();
    const headers = sum11[0];
    const dataRows = sum11[1];

    const sum22 = sum2();
    const headers2 = sum22[0];
    const dataRows2 = sum22[1];

    // Combine headers and data into the desired format
    data.push({
      name: 'Sum',
      data: [...dataRows],
      columns : [headers]
    },{
      name: 'Sum Detail',
      data: [...dataRows2],
      columns : [headers2]
    });
    exportToExcel(data,'Summary');
  }
  const sub_summary = () => {
    const dataTable_sum = tableSubSummary.current;
    // Extract headers from the table
    const headers = ["Data Sub Summary","",""];

    // Extract data from the table body
    const tableBody = dataTable_sum.querySelector('tbody');
    const rows = Array.from(tableBody.querySelectorAll('tr'));
    const dataRows = rows.map((row) => Array.from(row.querySelectorAll('td')).map((td) => td.textContent));
    // remove index 0 from dataRows
    dataRows.shift();
    for (let i = 0; i < dataRows.length; i++) {
      const first_col = dataRows[i][0];
      if (first_col === "Total") {
        // move index 1 to index 2
        dataRows[i][2] = dataRows[i][1];
        dataRows[i][1] = "";
      }
    }
    var row = 0; 
    var columns=0;
    var dataRows2 = [];
    for (let i=0; i < 100; i++) {
      dataRows2[i] = [];
    }
    for (let i = 0; i < dataRows.length; i++) {
      if(typeof dataRows[i][0] !== "undefined") {
        dataRows2[row][columns] = dataRows[i][0];
        dataRows2[row][columns+1] = dataRows[i][1];
        dataRows2[row][columns+2] = dataRows[i][2];
        dataRows2[row][columns+3] = "";
        if(dataRows[i][1] === "") {
          row = 0;
          columns+=4
        } else {
          row++;
        }
      }
    }
    for (let i = 0; i<columns; i++){
      headers.push("");
    }

    return [headers, dataRows2];
  }
  const onDownloadSUBSummary_process  = async () => {
    // open url export/GenerateExcel with post bln and thn
    

    const formData = new FormData();
    formData.append('bln', month_selected);
    formData.append('thn', year_selected);
    const response = await axios.post("https://ss8.my.id/go_8rIYikXHr54EpJhCZfCAC8uWnq2A8J0iOLiox5st0EIbMWFe/export/GenerateExcel", formData, config);
    const data = response.data;
    console.log(data);
    if (response.status === 200) {
      // proses open link
      window.open("https://ss8.my.id/go_8rIYikXHr54EpJhCZfCAC8uWnq2A8J0iOLiox5st0EIbMWFe/app-assets/" + data.file, '_blank');
      // enable button
      document.getElementById('btnDownloadsubsummary').disabled = false;
    }
  }
  const onDownloadSUBSummary  = () => {
    alert("Please wait, this process may take a few moments");
    // disabled button
    document.getElementById('btnDownloadsubsummary').disabled = true;
    onDownloadSUBSummary_process();
  }

  const sub_expenses = () => {
    const dataTable_sum = tableSubExpense.current;
    // Extract headers from the table
    const headers = ["Data Sub Expense","",""];

    // Extract data from the table body
    const tableBody = dataTable_sum.querySelector('tbody');
    const rows = Array.from(tableBody.querySelectorAll('tr'));
    const dataRows = rows.map((row) => Array.from(row.querySelectorAll('td')).map((td) => td.textContent));

    dataRows.shift();
    for (let i = 0; i < dataRows.length; i++) {
      const first_col = dataRows[i][0];
      if (first_col === "Total") {
        // move index 1 to index 2
        dataRows[i][2] = dataRows[i][1];
        dataRows[i][1] = "";
        // append empty row after total
        // dataRows.splice(i+1, 0, ["","",""]);
      }
    }
    var row = 0; 
    var columns=0;
    var dataRows2 = [];
    for (let i=0; i < 100; i++) {
      dataRows2[i] = [];
    }
    for (let i = 0; i < dataRows.length; i++) {
      if(typeof dataRows[i][0] !== "undefined") {
        dataRows2[row][columns] = dataRows[i][0];
        dataRows2[row][columns+1] = dataRows[i][1];
        dataRows2[row][columns+2] = dataRows[i][2];
        dataRows2[row][columns+3] = "";
        if(dataRows[i][1] === "") {
          row = 0;
          columns+=4
        } else {
          row++;
        }
      }
    }
    for (let i = 0; i<columns; i++){
      headers.push("");
    }

    return [headers, dataRows2];
  }
  const onDownloadExpense  = () => {
    const data = [];
    
    const sub_summary1 = sub_expenses();
    const headers = sub_summary1[0];
    const dataRows2 = sub_summary1[1];
    // Combine headers and data into the desired format
    data.push({
      name: 'Sum',
      data: [...dataRows2],
      columns : [headers]
    });
    exportToExcel(data,'Sub Expense');
  }
  const piutang1 = () => {

    // Process TablePiutang
    const dataTable_sum2 = tablePiutang.current;
    const headers = Array.from(dataTable_sum2.querySelectorAll('thead th')).map((th) => th.textContent);
    const tableBody = dataTable_sum2.querySelector('tbody');
    const rows = Array.from(tableBody.querySelectorAll('tr'));
    const dataRows = rows.map((row) => Array.from(row.querySelectorAll('td')).map((td) => td.textContent));
    for(let i=0; i<dataRows.length; i++) {
      if (dataRows[i][0] === "Total") {
        dataRows[i][4] = dataRows[i][1];
        dataRows[i][5] = dataRows[i][2];
        dataRows[i][1] = "";
        dataRows[i][2] = "";
        dataRows[i][3] = "";
      }
    }
    return [headers, dataRows];
  }
  const onDownloadPiutang  = () => {

    const data = [];

    const ppiutang1 = piutang1();
    const headers = ppiutang1[0];
    const dataRows = ppiutang1[1];

    // Combine headers and data into the desired format
    data.push({
      name: 'Piutang',
      data: [...dataRows],
      columns : [headers]
    });
    exportToExcel(data,'Piutang');
  }
  const onDownloadAll  = () => {
    const data = [];

    const pcash11 = pcash1();
    const headers = pcash11[0];
    const dataRows = pcash11[1];

    const pcash22 = pcash2();
    const headers2 = pcash22[0];
    const dataRows2 = pcash22[1];
    
    const sum11 = sum1();
    const headers_sum11 = sum11[0];
    const dataRows_sum11 = sum11[1];

    const sum22 = sum2();
    const headers2_sum22 = sum22[0];
    const dataRows2_sum22 = sum22[1];

    const sub_summary1 = sub_summary();
    const headers_sub1 = sub_summary1[0];
    const dataRows2_sub1 = sub_summary1[1];

    const sub_expenses1 = sub_expenses();
    const headers_sub_ex = sub_expenses1[0];
    const dataRows2_sub_ex = sub_expenses1[1];
    // Combine headers and data into the desired format
    data.push({
      name: 'P Cash Sum',
      data: [...dataRows],
      columns : [headers]
    },{
      name: 'P Cash Kas',
      data: [...dataRows2],
      columns : [headers2]
    },
    {
      name: 'Summary',
      data: [...dataRows_sum11],
      columns : [headers_sum11]
    },{
      name: 'Summary Detail',
      data: [...dataRows2_sum22],
      columns : [headers2_sum22]
    },{
      name: 'Sub Summary',
      data: [...dataRows2_sub1],
      columns : [headers_sub1]
    },{
      name: 'Sub Expense',
      data: [...dataRows2_sub_ex],
      columns : [headers_sub_ex]
    });

    exportToExcel(data,'Excel All');
  }
  const remove_dot = (dataRow) => {
    for (let i = 0; i < dataRow.length; i++) {
      if (typeof dataRow[i] === "undefined") {
        continue;
      }
      for (let j = 0; j < dataRow[i].length; j++) {
        if (typeof dataRow[i][j] === "undefined") {
          continue;
        }
        // try convert to float
        dataRow[i][j] = dataRow[i][j].replace(/\./g, '');
        if (parseFloat(dataRow[i][j]) >= 0) {
          dataRow[i][j] = parseFloat(dataRow[i][j]);
        }
      }
    }
    return dataRow;
  }
  const onDownloadAllClean  = () => {
    const data = [];

    const datainout = datainout1();
    const headersDataInOut = datainout[0];
    const dataRowsDataInOut = remove_dot(datainout[1]);

    const pcash11 = pcash1();
    const headers = pcash11[0];
    const dataRows = remove_dot(pcash11[1]);

    const pcash22 = pcash2();
    const headers2 = pcash22[0];
    const dataRows2 = remove_dot(pcash22[1]);
    
    const sum11 = sum1();
    const headers_sum11 = sum11[0];
    const dataRows_sum11 = remove_dot(sum11[1]);

    const sum22 = sum2();
    const headers2_sum22 = sum22[0];
    const dataRows2_sum22 = remove_dot(sum22[1]);

    const sub_summary1 = sub_summary();
    const headers_sub1 = sub_summary1[0];
    const dataRows2_sub1 = remove_dot(sub_summary1[1]);

    const sub_expenses1 = sub_expenses();
    const headers_sub_ex = sub_expenses1[0];
    const dataRows2_sub_ex = remove_dot(sub_expenses1[1])

    const piutang11 = piutang1();
    const headers_piutang = piutang11[0];
    const dataRows_piutang = remove_dot(piutang11[1]);

    // Combine headers and data into the desired format
    data.push({
      name: 'Data In Out',
      data: [...dataRowsDataInOut],
      columns : [headersDataInOut]
    },{
      name: 'P Cash Sum',
      data: [...dataRows],
      columns : [headers]
    },{
      name: 'P Cash Kas',
      data: [...dataRows2],
      columns : [headers2]
    },
    {
      name: 'Summary',
      data: [...dataRows_sum11],
      columns : [headers_sum11]
    },{
      name: 'Summary Detail',
      data: [...dataRows2_sum22],
      columns : [headers2_sum22]
    },{
      name: 'Sub Summary',
      data: [...dataRows2_sub1],
      columns : [headers_sub1]
    },{
      name: 'Sub Expense',
      data: [...dataRows2_sub_ex],
      columns : [headers_sub_ex]
    },{
      name: 'Piutang',
      data: [...dataRows_piutang],
      columns : [headers_piutang]
    });

    exportToExcel(data,'Excel All Numeric');
  }
  const onDownloadModalSummary  = () => {
    const data = [];

    const TabelPopup = tableModalSub1();
    const headersTabelPopup = TabelPopup[0];
    const dataRowsTabelPopup = remove_dot(TabelPopup[1]);

    // Combine headers and data into the desired format
    data.push({
      name: 'Detail Tabel',
      data: [...dataRowsTabelPopup],
      columns : [headersTabelPopup]
    });

    exportToExcel(data,'Excel All Tabel');
  }

  const [showModalSub, setShowModalSub] = useState(false);
  const [modalSubSummary, setModalSubSummary] = useState([]);
  const handleSubModal = (item,item1,item2) => {
    setShowModalSub(true);
    setIsLoadingModal(true);
    console.log(item,item1,item2);
    getModalSubSummary(item,item1,item2).then((data) => {
      setModalSubSummary(data);
      setIsLoadingModal(false);
    });
  };

  return (
    <div>
      <HeaderMenu title={"Report All Divisi"} subtitle={"Report All Divis"} />
      {/* <ToastContainer /> */}
      
      <div style={{ textAlign: 'center' }}>
        <table border={0}>
          <thead>
          </thead>
          <tbody>
            <tr>
              <td>
                <select style={selectStyle120} ref={selectForBln} className="js-example-basic-single style-select-report" value={selectedMonth || ""} onChange={handleChange}>
                <option value="">-PILIH-</option>
                  {months.map((month) => (
                    <option key={month.value} value={month.value}>
                      {month.label}
                    </option>
                  ))}
                </select>
              </td>
              <td>
              <select style={selectStyle120} ref={selectForYearh} className="js-example-basic-single style-select-report" value={selectedYear} onChange={handleChange}>
                  <option value="">-PILIH-</option>
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </td>  
              <td>
                <button onClick={onDownloadAllClean} className="btn btn-info"> Export Excel</button>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
      {/* <button onClick={onDownloadAll}> Export excel All </button> */}
      <div className="containers" style={{ width : "100%"}}>

        <ul className="tabs" style={{ width: "100%"}}>
          {/* <li className="tab-link" data-tab="tab-1">Summary</li> */}
          <li className="tab-link" data-tab="datainout">DataInOut</li>
          <li className="tab-link" data-tab="pcash88">P Cash SS88</li>
          <li className="tab-link current" data-tab="summary">Summary</li>
          <li className="tab-link " data-tab="subsummary">Sub Summary</li>
          <li className="tab-link" data-tab="subExpese">Sub Expense</li>
          {/* <li className="tab-link" data-tab="piutang">Piutang</li> */}
        </ul>


        <div id="datainout" className="tab-content">
          <div style={{ textAlign: 'center', overflow:'auto', height:'80vh', width:'100%'}}>

          {/* <DownloadTableExcel filename="Datainout" sheet="dataInOut" currentTableRef={tableDataInOut.current} ><button> Export excel </button></DownloadTableExcel> */}
            <table ref={tableDataInOut} className='table table-bordered' style={{ width:'600px'}}>
              <thead>
                <tr>
                  <th>Bank</th>
                  <th>In</th>
                  <th>Out</th>
                  <th style={{fontWeight:'bold'}}>Total</th>
                </tr>
              </thead>
              <tbody>
              { isLoading ? <tr><td>Loading...</td></tr> :
              Object.keys(DatainoutReportSumarryToko).map((item,index) => (
                <tr key={index}  style={item === "Total" ? { backgroundColor: "yellow" } : null}>
                        {/* <td style={{ textAlign:'left'}}>{item}</td>  */}
                        <td style={{ textAlign:'left', width:'240px'}}>{DatainoutReportSumarryToko[item]["bank"]}</td> 
                        <td style={{ textAlign:'right', width:'140px'}}>{formatNumberWithoutDecimals(DatainoutReportSumarryToko[item]["income_idr"])}</td> 
                        <td style={{ textAlign:'right', width:'140px'}}>{formatNumberWithoutDecimals(DatainoutReportSumarryToko[item]["nominal_idr"])}</td> 
                        <td style={{ textAlign:'right',fontWeight:'bold', width:'140px'}}>{formatNumberWithoutDecimals(DatainoutReportSumarryToko[item]["total"])}</td> 
                    </tr>
                // ))
              ))
              }
            </tbody>
            </table>
          </div>
        </div>
        <div id="pcash88" className="tab-content">
          <div style={{ textAlign: 'center', overflow:'auto', height:'80vh', width:'100%'}}>
          {/* <button onClick={onDownloadPCash}> Export excel </button> */}
            <table ref={tablePcash1} className='table table-bordered' style={{ width:'700px'}}>
              <thead>
                <tr>
                  <th>Keterangan</th>
                  <th>In</th>
                  <th>Out</th>
                  <th>Jumlah</th>
                </tr>
              </thead>
              <tbody>
              {isLoading ? <tr><td>Loading...</td></tr> :
              Object.keys(DatainoutSumarryReportToko).map((item,index) => (
                
                Object.keys(DatainoutSumarryReportToko[item]).map((item1, index) => (
                <tr key={index}  style={item1 === "Total" ? { backgroundColor: "yellow" } : null}>
                        <td style={{ textAlign:'left'}}>{item1}</td> 
                        <td style={{ textAlign:'right', fontWeight:'bold'}}>{formatNumberWithoutDecimals(DatainoutSumarryReportToko[item][item1]["iTotal"])}</td>
                        <td style={{ textAlign:'right', fontWeight:'bold'}}>{formatNumberWithoutDecimals(DatainoutSumarryReportToko[item][item1]["Total"])}</td>
                        <td style={{ textAlign:'right', fontWeight:'bold'}}>{formatNumberWithoutDecimals(DatainoutSumarryReportToko[item][item1]["sTotal"])}</td>
                    </tr>
                ))
              ))
              }
            </tbody>
            </table>
            {/* id 10 Jenius detail dipindahkan ke KAS IDR */}
            <table  ref={tablePcash2} className='table table-bordered' style={{ marginTop:'20px', width:'300px'}}>
              <thead>
                <tr>
                  <th>Keterangan</th>
                  <th>Jumlah</th>
                </tr>
              </thead>
              <tbody>

              { isLoading ? <tr><td>Loading...</td></tr> :
                  Object.keys(DatainoutReportSaldo["asset_list"]).map((item,index) => (
                    Object.keys(DatainoutReportSaldo["asset_list"][item]).map((item1, index) => (
                      <tr key={index}  style={item1 === "Total" ? { backgroundColor: "yellow" } : null}>
                      <td style={{ textAlign:'left'}}>{item1}</td>
                      <td style={{ textAlign:'right', fontWeight:'bold'}}>{formatNumberWithoutDecimals(DatainoutReportSaldo["asset_list"][item][item1])}</td>
                    </tr>
                    ))
                  ))
                  }
              </tbody>
            </table>
            <table  ref={tablePcash3} className='table table-bordered' style={{ marginTop:'20px', width:'800px'}}>
              <thead>
                <tr>
                  <th>Kas</th>
                  <th>Saldo Awal</th>
                  <th>DataInOut</th>
                  <th>In</th>
                  <th>Out</th>
                  <th>Transfer</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>

              { isLoading ? <tr><td>Loading...</td></tr> :
                  Object.keys(DatainoutReportSaldo["bank_list"]).map((item,index) => (
                    // Object.keys(DatainoutReportSaldo["bank_list"][item]).map((item1, index) => (
                      <tr key={index}  style={item === "Total" ? { backgroundColor: "yellow" } : null}>
                      <td style={{ textAlign:'left'}}>{DatainoutReportSaldo["bank_list"][item]}</td>
                      <td style={{ textAlign:'right', fontWeight:'bold'}}>{formatNumberWithoutDecimals(DatainoutReportSaldo["saldo_awal"][item])}</td>
                      <td style={{ textAlign:'right', fontWeight:'bold'}}>{formatNumberWithoutDecimals(DatainoutReportSaldo["income_list"][item])}</td>
                      <td style={{ textAlign:'right', fontWeight:'bold'}}>{formatNumberWithoutDecimals(DatainoutReportSaldo["ex_in_list"][item])}</td>
                      <td style={{ textAlign:'right', fontWeight:'bold'}}>{formatNumberWithoutDecimals(DatainoutReportSaldo["expense_list"][item])}</td>
                      <td style={{ textAlign:'right', fontWeight:'bold'}}>{formatNumberWithoutDecimals(DatainoutReportSaldo["transfer_kas"][item])}</td>
                      <td style={{ textAlign:'right', fontWeight:'bold'}}>{formatNumberWithoutDecimals(DatainoutReportSaldo["total_transaksi"][item])}</td>
                    </tr>
                    // ))
                  ))
                  }
              </tbody>
            </table>
            <h1>&nbsp;</h1>
            <h1>&nbsp;</h1>
            <h1>&nbsp;</h1>
          </div>
        </div>
        <div id="summary" className="tab-content current">
          <div style={{ textAlign: 'center', overflow:'auto', height:'80vh',}}>
          {/* <button onClick={onDownloadSummary}> Export excel </button> */}
            <table ref={tableSumRef1} className='table table-bordered'>
              <thead>
                <tr>
                  <th>Keterangan</th>
                  <th>Jumlah</th>
                </tr>
              </thead>
              <tbody>
              {isLoading ? <tr><td>Loading...</td></tr> :
              Object.keys(AssetSumarryReportToko).map((item,index) => (
                
                Object.keys(AssetSumarryReportToko[item]).map((item1, index) => (
                <tr key={index}  style={item1 === "Total" ? { backgroundColor: "yellow" } : null}>
                        <td style={{ textAlign:'left'}}>{item1}</td> 
                        <td style={{ textAlign:'right', fontWeight:'bold'}}>{formatNumberWithoutDecimals(AssetSumarryReportToko[item][item1]["Total"])}</td>
                    </tr>
                ))
              ))
              }
            </tbody>
            </table>
            <table  ref={tableSumRef2} className='table table-bordered' style={{ marginTop:'20px'}}>
              <thead>
                <tr>
                  <th>Keterangan</th>
                  { isLoading ? <tr><td>Loading...</td></tr> :
                  KasList && KasList.map((item,index) => (
                    item.value === "" ? null  : <th style={{ width:'120px'}}>{item.label}</th>
                  ))
                  }
                  <th>Jumlah</th>
                </tr>
              </thead>
              <tbody>
              { isLoading ? <tr><td>Loading...</td></tr> :
              Object.keys(AssetSumarryReportToko).map((item,index) => (
                Object.keys(AssetSumarryReportToko[item]).map((item1, index) => (
                <tr key={index}  style={item1 === "Total" ? { backgroundColor: "yellow" } : null}>
                  {item1 === "Total" ? <td style={{ textAlign:'left'}}  >{item1}</td> : <td style={{ textAlign:'left'}}>{item1}</td> }

                  {KasList && KasList.map((item2,index2) => (
                    item2.value === "" ? null : <td style={{ textAlign:'right'}}>{formatNumberWithoutDecimals(AssetSumarryReportToko[item][item1][item2.label])}</td>
                  ))}
                  <td style={{ textAlign:'right', fontWeight:'bold'}}>{formatNumberWithoutDecimals(AssetSumarryReportToko[item][item1]["Total"])}</td>
                </tr>
                ))
              ))
              }
            </tbody>
            </table>
            <h1>&nbsp;</h1>
            <h1>&nbsp;</h1>
            <h1>&nbsp;</h1>
          </div>
        </div>
        <div id="subExpese" className="tab-content">
          <div style={{ textAlign: 'center', overflow:'auto', height:'80vh', width:'100%'}}>
          {/* <button onClick={onDownloadExpense}> Export excel </button> */}
            <table ref={tableSubExpense} className=''>
              <tbody>
                <tr>
                  
              { isLoading ? <tr><td>Loading...</td></tr> :
              ReportPusatToko && ReportPusatToko.map((category,categoryIndex) => (

              Object.keys(category).map((item,index) => (
                <td style={{ verticalAlign:'top'}}><table style={{ width: "420px", float:"left"}} className='table table-bordered'>
                  <tbody>
                <tr key={randomKey+"tr"}>
                  <td colSpan="3" key={randomKey+item}>{item}</td>
                </tr>
                <tr>
                  <td>P.Cash</td>
                  <td>Account</td>
                  <td>Jumlah</td>
                </tr>
                  {category[item] && Object.keys(category[item]).map((item2,index2) => (
                    category[item][item2] && Object.keys(category[item][item2]).map((item3,index3) => (
                      <tr style={item2 === "ZZTotal" ? { backgroundColor: "yellow" } : null}>
                        { item2 === "ZZTotal" ? <td style={{ textAlign:'left'}} colSpan="2">Total</td> :
                          <td style={{ textAlign:'left'}} onClick={() => handleSubModal(item,item3,item2)}>{item2}</td>
                        }
                        {item3 === "Total" ? null : 
                        <td style={{ textAlign:'left'}} onClick={() => handleSubModal(item,item3,item2)}>{item3}</td>
                        }
                        <td style={{ textAlign:'right'}}>{formatNumberWithoutDecimals(category[item][item2][item3])}</td>
                      </tr>
                    ))
                  ))}
                  </tbody>
                  </table>
                  </td>
                ))
              ))}
              </tr>
            </tbody>
            </table>
            <h1>&nbsp;</h1>
            <h1>&nbsp;</h1>
            <h1>&nbsp;</h1>
            </div>
        </div>
        <div id="subsummary" className="tab-content">
          
          <div style={{ textAlign: 'center', overflow:'auto', height:'80vh', width:'100%'}}>
          {<button id="btnDownloadsubsummary" onClick={onDownloadSUBSummary} className="btn btn-info"> Export Detail </button> }
            <table ref={tableSubSummary} className='table table-bordered' style={{ width:'420px'}}>
              <tbody>
                <tr>
                  
              { isLoading ? <tr><td>Loading...</td></tr> :
              ReportPusat && ReportPusat.map((category,categoryIndex) => (

              Object.keys(category).map((item,index) => (
                <th style={{ verticalAlign:'top'}}><table style={{ width: "840px", float:"left"}} className='table table-bordered'>
                  <tbody>
                <tr key={randomKey+"tr"}>
                  <td colSpan="3" key={randomKey+item}>{item}</td>
                </tr>
                <tr>
                  <td>Account</td>
                  <td>Sub Account</td>
                  <td>Jumlah</td>
                </tr>
                  {category[item] && Object.keys(category[item]).map((item2,index2) => (
                    category[item][item2] && Object.keys(category[item][item2]).map((item3,index3) => (
                      <tr style={item2 === "ZZTotal" ? { backgroundColor: "yellow" } : null}>
                        { item2 === "ZZTotal" ? <td style={{ textAlign:'left'}} colSpan="2">Total</td> :
                          <td style={{ textAlign:'left'}} onClick={() => handleSubModal(item,item2,item3)}>{item2}</td>
                        }
                        {item3 === "Total" ? null : 
                        <td style={{ textAlign:'left'}}>{item3}</td>
                        }
                        <td style={{ textAlign:'right'}}>{formatNumberWithoutDecimals(category[item][item2][item3])}</td>
                      </tr>
                    ))
                  ))}
                  </tbody>
                  </table>
                  </th>
                ))
              ))}
              </tr>
            </tbody>
            </table>
            <h1>&nbsp;</h1>
            <h1>&nbsp;</h1>
            <h1>&nbsp;</h1>
            </div>
        </div>
        <div id="piutang" className="tab-content">
          <div style={{ textAlign: 'center', overflow:'auto', height:'80vh', width:'100%'}}>
          {/* <button onClick={onDownloadPiutang}> Export excel </button> */}
            <table ref={tablePiutang} className='table table-bordered'>
              <thead>
                <tr>
                  <th>Tanggal</th>
                  <th>Tanggal Keluar</th>
                  <th style={{ width: '150px'}}>Keterangan</th>
                  <th style={{ width: '120px'}}>Asset</th>
                  <th style={{ width: '120px'}}>Masuk</th>
                  <th style={{ width: '120px'}}>Keluar</th>
                </tr>
              </thead>
              <tbody>
              { isLoading ? <tr><td>Loading...</td></tr> :
              ReportPiutang && ReportPiutang.map((category,categoryIndex) => (
                <tr style={category.keterangan === "Total" ? { backgroundColor: "yellow" } : null}>
                  {category.keterangan === "Total" ? null : <td>{category.tanggal}</td> }
                  {category.keterangan === "Total" ? null : <td>{category.tanggal_byr}</td> }
                  {category.keterangan === "Total" ? <td colSpan="4">{category.keterangan}</td>  : <td>{category.keterangan}</td> }
                  {category.keterangan === "Total" ? null : <td>{category.asset}</td>}
                  <td style={{ textAlign:"right"}}>{formatNumberWithoutDecimals(category.nominal_idr)}</td>
                  <td style={{ textAlign:"right"}}>{formatNumberWithoutDecimals(category.keluar)}</td>
                </tr>
              ))}
            </tbody>
            </table>
            <h1>&nbsp;</h1>
            <h1>&nbsp;</h1>
            <h1>&nbsp;</h1>
            </div>
        </div>
      </div>
      {showModalSub && (
        
        <div className="modal fade"  aria-hidden="true">
            <div className="modal-dialog" style={{ width:'80%', margin: '5% auto', height:'80%'}}>
              <div className="modal-content">
                <div className="modal-header">

                  <h5 className="modal-title" id="exampleModalLabel">Detail Sub Summary</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" style={{ position:'fixed', top:'0px', right:'0px'}}  onClick={() => setShowModalSub(false)}><i className='fa fa-close'></i></button>
                </div>
                <div className="modal-body" style={{ overflow:'auto', height:'80%'}}>
                  { isLoadingModal ? <tr><td>Loading...</td></tr> :
                  <><div>
                    <button onClick={onDownloadModalSummary} className="btn btn-info"> Export Excel</button>
                  </div>
                  <table ref={tableModalSub} className='table table-bordered' style={{ width: '80%' }}>
                      <thead>
                        <tr style={{ backgroundColor: '#e8e8e8' }}>
                          <th>No</th>
                          <th>Tanggal</th>
                          <th>Bank</th>
                          <th>Kategori</th>
                          <th>Keterangan</th>
                          <th>Jumlah</th>
                        </tr>
                      </thead>
                      <tbody>
                        {modalSubSummary && modalSubSummary.map((category, categoryIndex) => (
                          <tr>
                            <td>{categoryIndex + 1}</td>
                            <td>{category.tanggal}</td>
                            <td>{category.bank}</td>
                            <td>{category.kategori}</td>
                            <td align='left'>{category.keterangan}</td>
                            <td align='right'>{formatNumberWithoutDecimals(category.nominal_idr)}</td>
                            {/* <td>{category.asset_awal}</td> */}
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr style={{ backgroundColor: "yellow" }}>
                          <th colSpan="5" align="right"><strong>Total:</strong></th>
                          <th align="right">
                            {modalSubSummary && formatNumberWithoutDecimals(
                              modalSubSummary.reduce((sum, category) => sum + Number(category.nominal_idr), 0)
                            )}
                          </th>
                        </tr>
                      </tfoot>
                    </table></>
                    }
                </div>
              </div>
            </div>

          </div>
      )}
    </div>
    
  );
};


export default ReportAllDivision;